import { render } from "./MyPageBoard.vue?vue&type=template&id=346643e4"
import script from "./MyPageBoard.vue?vue&type=script&lang=js"
export * from "./MyPageBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__